import { spacing } from "@mui/system";
import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import styled from "styled-components/macro";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Hidden, CssBaseline, Paper as MuiPaper } from "@mui/material";

import { Footer } from "./misc/footer";
import Navbar from "../components/navbar/navbar";
import Sidebar from "../components/sidebar/sidebar";
import GlobalStyle from "../services/styles/global";
import { navItems } from "../components/sidebar/sidebarMenu";

const drawerWidth = 258;
const Root = styled.div`
  display: flex;
  min-height: 100vh;
`;

const Drawer = styled.div`
  -ms-overflow-style: none;
  scrollbar-width: none;
  ${(props) => props.theme.breakpoints.up("md")} {
    width: ${drawerWidth}px;
    flex-shrink: 0;
  }
`;

const AppContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  max-width: 100%;
`;

const Paper = styled(MuiPaper)(spacing);
const MainContent = styled(Paper)`
  flex: 1;
  background: ${(props) => props.theme.palette.background.default};

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    flex: none;
  }

  .MuiPaper-root .MuiPaper-root {
    box-shadow: none;
  }
`;

export const MainLayout = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => setMobileOpen(!mobileOpen);

  const theme = useTheme();
  const isLgUp = useMediaQuery(theme.breakpoints.up("lg"));

  return (
    <Root>
      <CssBaseline />
      <GlobalStyle />
      <Drawer>
        <Hidden lgUp implementation="js">
          <Sidebar
            PaperProps={{ style: { width: drawerWidth } }}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            items={navItems}
          />
        </Hidden>
        <Hidden mdDown implementation="css">
          <Sidebar
            PaperProps={{ style: { width: drawerWidth } }}
            items={navItems}
          />
        </Hidden>
      </Drawer>
      <AppContent>
        <Navbar
          onDrawerToggle={handleDrawerToggle}
          title="Dashboard"
        />
        <MainContent p={isLgUp ? 12 : 5} sx={{ marginTop: "-1.5rem" }}>
          {children}
          <Outlet />
        </MainContent>
        <Footer />
      </AppContent>
    </Root>
  );
};
